import eventBus from '../core.js';

const eventName = 'handleCloseModal';

const subscribe = callback => {
    return eventBus.subscribe(eventName, callback);
};

const broadcast = data => {
    return eventBus.broadcast(eventName, data);
};

export default {
    subscribe,
    broadcast,
};
